const SmallLoading = () => {
  return (
    <div className="spinner">
      <div className="spinner-inner"></div>
    </div>
  );
};

export default SmallLoading;
